// @flow
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import Box from '@material-ui/core/Box';
import { Tabs, Tab, Link } from '@material-ui/core';
import { useStores } from '../stores';
import appStyles from '../../../config/appStyles.js';
import Progress from './common/Progress';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => appStyles.collectionTabs(theme));

const CollectionTabs = observer((props) => {
  const classes = useStyles();
  const { orderStore, userStore } = useStores();
  const { user } = userStore;
  const { t } = useTranslation();

  const {
    isLoadingOrders,
    hasOrders,
    orders,
    currentOrder,
    orderTypes,
    getBackIssueOrders,
  } = orderStore;

  const handleChange = (event, newCurrentOrderId) => {
    orderStore.setCurrentOrderById(newCurrentOrderId);
  };

  return isLoadingOrders || !currentOrder ? (
    <Box className={classes.collectionContainer}>
      {isLoadingOrders && hasOrders && <Progress variant="small" />}
    </Box>
  ) : (
    <Box className={classes.collectionContainer}>
      <Tabs
        value={
          currentOrder.type === orderTypes.backissue ||
          currentOrder === orderTypes.backissue
            ? orderTypes.backissue
            : currentOrder.id
        }
        classes={{
          indicator: classes.indicator,
          scrollButtons: classes.scrollButtons,
        }}
        textColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs example"
        scrollButtons="auto"
        variant="scrollable">
        {hasOrders &&
          orders.map((order) => {
            if (order.type === orderTypes.subscription) {
              return (
                <Tab
                  classes={{ selected: classes.selected }}
                  key={`collectiontab_${order.id}`}
                  className={classes.collectionTab}
                  value={order.id}
                  label={
                    <div className={classes.avatarWrapper}>
                      {order && order?.variantAttributes?.thumb && (
                        <div className={classes.imgCont}>
                          <img
                            src={order.variantAttributes.thumb.src}
                            alt={order.variantAttributes.thumb.alt}
                          />
                        </div>
                      )}
                      <Box
                        className={classes.singleTab}
                        sx={{
                          width: order?.variantAttributes?.thumb?.src
                            ? '76.4%'
                            : '100%',
                        }}
                        display="flex"
                        alignItems="center"
                        justifyContent="center">
                        <span>{order.short}</span>
                      </Box>
                    </div>
                  }
                />
              );
            }
          })}

        {getBackIssueOrders.length > 0 && (
          <Tab
            key={`backissuestab`}
            classes={{ selected: classes.selected }}
            className={classes.collectionTab}
            value={orderTypes.backissue}
            label={
              <div className={classes.avatarWrapper}>
                <Box
                  className={classes.singleTab}
                  sx={{
                    width: '100%',
                  }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center">
                  <span>
                    {t('components:Backissues.tabLabel', {
                      number: getBackIssueOrders.length,
                    })}
                  </span>
                </Box>
              </div>
            }
          />
        )}
      </Tabs>
    </Box>
  );
});

export default CollectionTabs;
